import React from "react";
import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import {
  LOGO_ICON,
  PHONE_DISPLAY,
  PHONE_TEL,
  EMAIL,
  SERVICE_AREA,
  SERVICE_COUNTIES,
} from "@/lib/brand";

export default function SiteFooter() {
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img src={LOGO_ICON} alt="" className="w-12 h-12 rounded-full" />
              <div>
                <div className="font-display font-bold text-white text-lg leading-tight">
                  Heavenly Home &amp; Office
                </div>
                <div className="text-xs text-slate-400">Cleaning · Handyman · Home Services</div>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-xs">
              One trusted team for cleaning, handyman work, yard help, and tech setup — treating
              every property like our own.
            </p>
          </div>

          <div>
            <div className="text-sm font-semibold uppercase tracking-widest text-slate-200 mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`tel:${PHONE_TEL}`}
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                  data-testid="footer-phone-link"
                >
                  <Phone size={16} weight="bold" className="text-sky-400" />
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  className="inline-flex items-center gap-2 hover:text-white transition-colors break-all"
                  data-testid="footer-email-link"
                >
                  <EnvelopeSimple size={16} weight="bold" className="text-sky-400" />
                  {EMAIL}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-sm font-semibold uppercase tracking-widest text-slate-200 mb-4">
              Service Area
            </div>
            <div className="text-sm flex items-start gap-2">
              <MapPin size={18} weight="bold" className="text-sky-400 mt-0.5 shrink-0" />
              <div>
                <div className="text-slate-200">{SERVICE_AREA}</div>
                <div className="text-slate-400 mt-1">
                  Serving {SERVICE_COUNTIES.join(", ")} counties and surrounding communities.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Heavenly Home And Office. All rights reserved.</div>
          <Link
            to="/admin/login"
            className="hover:text-slate-300 transition-colors"
            data-testid="admin-link"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
